var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"topHeader"},[_c('topHeader')],1),_c('div',{staticClass:"context"},[_c('div',{staticClass:"menuTreeBox"},[_c('menuTree')],1),_c('div',{staticClass:"container"},[_c('container')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }